export type DownloadReportInfo = {
  link: string;
  status: string;
  fileName: string;
};

export const isDownloadReportInfo = (obj: any): obj is DownloadReportInfo => {
  return typeof obj.link === "string" && typeof obj.status === "string";
};
